import { render, staticRenderFns } from "./checkbox.html?vue&type=template&id=36f8f63e&scoped=true&external"
import script from "./checkbox.js?vue&type=script&lang=js&external"
export * from "./checkbox.js?vue&type=script&lang=js&external"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=36f8f63e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8f63e",
  null
  
)

export default component.exports